import { formatPrice } from 'src/utilities/helpers';

export class OrderLine {
  constructor (orderLine) {
    this.product = null;
    this.shoppingCartId = orderLine.ShoppingCartId;
    this.productId = orderLine.ProductId;
    this.quantity = parseInt(orderLine.Quantity);
    this.computedQuantity = null;
    this.totalOrderLinesQuantity = orderLine.TotalCount;
    this.rawQuantity = parseInt(orderLine.Quantity);
    this.unitCode = orderLine.UnitCode;
    this.isFree = orderLine.IsFree;
    this.lineId = orderLine.LineId;
    this.comments = orderLine.Comments;
    this.customFields = orderLine.CustomFields;
    this.exceedsStock = false;
    this.totals = {
      price: '',
      rawPrice: 0
    };
  }

  setProduct (product) {
    this.product = product;
  }

  getComputedQuantity () {
    let quantity = this.quantity;
    if (this.product.units) {
      // BESPOKE NOX
      // Since all the quantity controls are displayed multiplied by a quantity factor of the product saleunit
      // we need to divide the quantity by the sale unit again when we use it to calculate the total orderline price
      quantity = this.product.units.filter(unit => unit.code === this.unitCode)[0].quantity * (this.quantity / 100);
    } else if (this.product.saleUnit > 1) {
      quantity = this.product.saleUnit * this.quantity;
    }
    return quantity;
  }

  setComputedQuantity () {
    this.computedQuantity = this.getComputedQuantity();
  }

  setOrderLineTotal () {
    let price, totals;
    const quantity = this.getComputedQuantity();

    let volumeIndex = 0;

    this.product.prices.forEach((price, index) => {
      if (quantity >= price.quantity) {
        volumeIndex = index;
      }
    });

    price = this.product.prices[volumeIndex].rawPrice;
    totals = price * quantity;

    this.totals = {
      price: formatPrice(price),
      rawPrice: price,
      totalPrice: formatPrice(totals),
      totalRawPrice: totals,
      isSalesAction: this.product.prices[volumeIndex].isSalesAction
    };
  }
}
